import { sendEmailVerification } from 'firebase/auth'
import { Button } from 'react-bootstrap'
import toast from 'react-hot-toast'

import { auth } from '../../../../firebase'

const VerifyEmail = () => {
  const handleEmailVerified = () => {
    window.location.reload()
  }

  const handleSendEmail = async () => {
    try {
      await sendEmailVerification(auth.currentUser)

      toast.success("Verification email sent")
    } catch (error) {
      toast.error("Failed to send verification email")
      console.error(error)
    }
  }

  return (
    <>
      <h1 className="mb-4 fs-2 fw-semibold">Email Verification Required</h1>
      <p className="mb-4">
        Check your inbox for a verification email and follow the instructions. <br />
        If you can't find the email, check your spam/junk folder or click "Resend Email". <br />
        Once verified, click "I've verified my email" to continue.
      </p>
      <div className="d-flex flex-column justify-content-center gap-2">
        <Button
          className="mt-2 px-5 rounded-3 shadow-btn"
          variant="dark"
          onClick={handleEmailVerified}
        >
          I've verified my email
        </Button>
        <Button
          className="mt-2 px-5 rounded-3 shadow-btn border-light"
          variant=""
          onClick={handleSendEmail}
        >
          Resend Email
        </Button>
      </div>
    </>
  )
}

export default VerifyEmail